import React, { useState } from "react"
import { IProduct } from "../../views/ecommerce/products/interfaces";
import StepOne from "../FormStepProduct/stepOne";
import StepThree from "../FormStepProduct/stepThree";
import StepTwo from "../FormStepProduct/stepTwo";
import ModalActions from "../ModalActions";
import { AddProductHeader, AddProductHeaderPage } from "./style"

const ModalCreatedProduct = (): React.ReactElement => {
    const [step, setStep] = useState(1);
    const [productData, setProductData] = useState<IProduct>()
    const STEP_ONE_STRING = "1"
    const STEP_TWO_STRING = "2"
    const STEP_TRHEE_STRING = "3"
    const STEP_ONE = 1
    const STEP_TWO = 2
    const STEP_TRHEE = 3


    return (
        <ModalActions 
            id="addProduct" 
            title="Adicionar do produto" 
            subtitle="Adicionar produto e suas variação e imagens."
        >
            <AddProductHeader >
                <AddProductHeaderPage 
                    data-step={STEP_ONE_STRING}
                    isActualOrPrevius={true} 
                    onClick={() => setStep(STEP_ONE)}
                >
                    Produto
                </AddProductHeaderPage>

                <AddProductHeaderPage 
                    data-step={STEP_TWO_STRING}
                    isActualOrPrevius={step > STEP_ONE} 
                    onClick={() => setStep(STEP_TWO)}
                >
                    Variações
                </AddProductHeaderPage>

                <AddProductHeaderPage 
                    data-step={STEP_TRHEE_STRING}
                    isActualOrPrevius={step >= STEP_TRHEE} 
                    onClick={() => setStep(STEP_TRHEE)}
                >
                    Imagens
                </AddProductHeaderPage>
            </AddProductHeader>
                {step === STEP_ONE && <StepOne setStep={setStep} setData={setProductData}/>}
                {step === STEP_TWO && <StepTwo setStep={setStep} data={productData}/>}
                {step === STEP_TRHEE && <StepThree  setStep={setStep} data={productData}/>}
        </ModalActions>
    )
}

export default ModalCreatedProduct